<template>
  <v-card width="350" class="mx-auto mt-0">
    <v-card-title class="text-center">
      <span class="display-1">Loggable Login</span>
      <div class="caption mt-3">
        New to Loggable?
        <Button @click="item.showRegister" class="btn-login">Create an Account</Button>
      </div>
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text class="mt-5">
      <v-form>
        <v-text-field label="Email" prepend-icon="mdi-email" v-model="email" />
        <v-text-field
          :type="showPassword ? 'text' : 'password'"
          v-model="password"
          label="Password"
          prepend-icon="mdi-lock"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
        />
      </v-form>
    </v-card-text>
    <v-card-actions class="mt-n8 mb-2">
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        :loading="loading"
        :disabled="loading"
        @click="loginWithEmailAndPassword"
      >Login</v-btn>
    </v-card-actions>

    <v-divider></v-divider>

    <v-card-title>
      <v-flex text-xs-center>
        <span class="body-2 text-center ml=5" @click="prefill">or sign in with</span>
      </v-flex>
    </v-card-title>

    <v-card-actions class="text-center d-inline-flex mt-n3">
      <v-btn class="ma-2" tile outlined color="success" @click="loginWithFacebook">
        <v-icon left>mdi-facebook</v-icon>Facebook
      </v-btn>
      <v-btn class="ma-2" tile outlined color="success" @click="loginWithGoogle">
        <v-icon left>mdi-google</v-icon>Google
      </v-btn>
    </v-card-actions>
    <v-divider></v-divider>

    <template v-if="this.error">
      <v-divider></v-divider>
      <p class="aa-error">{{ error }}</p>
    </template>
  </v-card>
</template>


<script>
import { signinWithEmailAndPassword, signinWithGoogle } from "../../auth";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      loading: false,
      email: "", // marcel@gmail.com
      password: "", // marcel5
      showPassword: false,
      error: "",
    };
  },
  computed: {},
  name: "DialogClientDetails",
  methods: {
    prefill() {
      this.email = "marcel@gmail.com";
      this.password = "marcel5";
    },
    loginWithEmailAndPassword() {
      signinWithEmailAndPassword(this.email, this.password, (err) => {
        debugger;
        this.loading = false;
        this.setError(err);
      });
      this.loading = true;
    },
    loginWithFacebook() {
      //signinWithGoogle((err) => this.setError(err));
      this.setError("Sorry , only signup with Google is currently allowed.");
    },
    loginWithGoogle() {
      signinWithGoogle((err) => this.setError(err));
    },
    setError(err) {
      this.error = err;
      this.loading = false;
      setTimeout(() => {
        this.error = "";
      }, 5000);
    },
  },
  watch: {
    "$store.state.loginError": function (newError) {
      this.error = newError;
    },
  },
};
</script>


<style scoped>
.btn-login {
  color: blue;
  margin-left: 5px;
}
.aa-error {
  color: red;
  padding: 10px;
}

.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>